import {Component, Input, ViewEncapsulation} from '@angular/core';
import {IoniconsOutline} from '@pt/pt-models';
import {DetailsPageError} from './models';

@Component({
  selector: 'pt-details-page-wrapper',
  template: `
    <div *ngIf='!loading && !errorOccurredExists()'>
      <ng-content select='[customDetails]'></ng-content>
      <div class='px-2'>
        <ng-content select='[customExtraDetails]'></ng-content>
        <ng-content select='[customTables]'></ng-content>
      </div>
    </div>

    <pt-loader *ngIf='loading'></pt-loader>

    <div *ngIf='!loading && errorOccurredExists()'
         class='h-100 w-100 d-flex flex-column justify-content-center align-items-center'>
      <div class='text-center'>
        <pt-icon class='text-warning' [key]='IconWarning' [size]='30'></pt-icon>
        <p>{{ errorOccurred?.getError()?.messageKey | translate }}</p>
      </div>
    </div>
  `,
  styles: [`
    pt-loader div {
      height: 100%;
      flex-direction: row;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .alert, pt-details-card .card-detail, pt-risk-factor-chart .chart-container {
      margin: 10px 0 !important;
    }
  `],
  encapsulation: ViewEncapsulation.None
})
export class DetailsPageWrapperComponent {

  IconWarning = IoniconsOutline.warning;
  @Input() loading: boolean;
  @Input() errorOccurred: DetailsPageError;

  errorOccurredExists() {
    return this.errorOccurred ? Object.keys(this.errorOccurred).length : null;
  }
}
